// Libraries
import React from "react"
import PropTypes from "prop-types"
import Icon from "components/Stacker/components/Icon/Icon"

// Styles
import "./Loader.scss"
import { useI18nContext } from "i18n/i18n-react"

// Implemented using - https://connoratherton.com/loaders
export default function Loader({ micro, additionalClassNames = "" }) {
  const { LL } = useI18nContext()
  return (
    <div className={`Loader ${additionalClassNames}`}>
      {!micro && (
        <div className="loader">
          <div className="loader-inner dy-logo-loader d-flex justify-content-center align-items-center flex-column">
            <Icon
              additionalClassNames="dy-logo-loader-icon"
              iconName="icon-dy-logo-mobile"
            />
            <p>{LL.generic.loadingText()}</p>
          </div>
        </div>
      )}

      {micro && (
        <div className="loader">
          <div className="loader-inner micro-loader">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
    </div>
  )
}

Loader.propTypes = {
  micro: PropTypes.bool,
  additionalClassNames: PropTypes.string,
}
